import { render, staticRenderFns } from "./GenericRatingComponent.vue?vue&type=template&id=d1d2fb84"
import script from "./GenericRatingComponent.vue?vue&type=script&lang=js"
export * from "./GenericRatingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports